import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function shopDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/shop/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
